import { swedishCountryCodeString } from './swedishCountryCode';

export const swedishPhoneNumber = new RegExp(`^(${swedishCountryCodeString})(70|72|73|76|79)\\d{7}$`);
